import { HttpService } from '@/utils/http/index'
import { joinParams } from '@/utils/index'

const $http = new HttpService()

/**
 * 获取券包列表
 * @param {integer} coupon_id - 券包 ID
 * @param {integer} coupon_type - 券包 ID
 * @returns {object}
*/
export const getPackageList = (params:object = {}) => $http.get('/admin/coupons/get_coupon_list', params)
/**
 * 添加/编辑券包
*/
export const savePackage = (params:object = {}) => $http.post('/admin/coupons/save_coupon', params)
/**
 * 获取券包详情
*/
export const getPackageDetail = (id:any) => $http.get('/admin/coupons/get_info', { id })
/**
 * 生成券码
*/
export const generateCoupon = (coupon_id:any) => $http.post('/admin/coupons/save_coupon_no', {coupon_id})
/**
 * 获取券码列表：根据上述任一条件进行搜索，获取券码列表
 * @param {integer} coupon_id - 券包 ID（多个用“,“分隔）
 * @param {integer} status - 券码状态（-5未激活、-4待激活、-1已作废、0已激活、1已绑定）
 * @param {integer} start_id - 券码开始 ID
 * @param {integer} end_id - 券码结束 ID
 * @param {string} ids - 券码结束 ID
 * @returns {object}
*/
export const getCouponList = (params:object = {}) => $http.get('/admin/coupons/getUserCouponsList', params)
/**
 * 获取券码激活列表
*/
export const getActivationList = (params:object = {}) => $http.get('/admin/coupons/getActivationList', params)

/**
 * 获取券码作废列表
*/
export const getCancelList = (params:object = {}) => $http.get('/admin/coupons/getTovoidList', params)

/**
 * 检查当前搜索条件下查出来的券码是否全部可进行激活
*/
export const checkActivation = (params:object = {}) => $http.get('/admin/coupons/getIsActivation', params)

/**
 * 保存券码编辑
*/
export const saveCoupon = (data:object = {}) => $http.post('/admin/coupons/applyActivation', data)

/**
 * 根据激活列表 ID，获取当前激活批次详细信息
*/
export const getActivationDetail = (params:object = {}) => $http.get('/admin/coupons/getActivationInfo', params)

/**
 * 保存审核结果（激活、驳回）
*/
export const saveCheck = (data:object = {}) => $http.post('/admin/coupons/sendApproval', data)

/**
 * 券码作废
*/
export const cancelCoupon = (data:object = {}) => $http.post('/admin/coupons/sendTovoid', data)

/**
 * 根据条件导出券码
*/
export const exportCoupon = (params:object = {}) => $http.get('/admin/coupons/exportUserCouponsData', params)

/**
 * 获取卡销售列表
*/
export const getSoldList = (params:object = {}) => $http.get('/admin/coupons/getCouponSaleList', params)

/**
 * 获取卡销售记录
*/
export const getSoldLog = (params:object = {}) => $http.get('/admin/coupons/getCouponSaleListLog', params)

/**
 * 获取卡券统计列表
*/
export const getStatisticsList = (params:object = {}) => $http.get('/admin/coupons/get_finance_list', params)

/**
 * 获取卡券消费列表
 *      coupon_id：券包ID
 *      order_type：订单类型，1-默认，实物；2-电子券
*/
export const getConsumeListApi = (params:object = {}) => $http.get('/admin/coupon_lots/getCouponConsumeList', params)
/**
 *权限修改接口
 *      info：1获取表单默认数据，修改无需此参数
*/
export const onPowerApi = (params:object = {}) => $http.post('/admin/coupons/saveCouponRule', params)

/**
 * 获取过期卡券列表
 *      status：0-待处理，1-已换券，2-已作废
 *      brand_name：品牌名称
 *      amount：面值
 *      coupon_name：券名
*/
export const getExpiredListApi = (params:object = {}) => $http.get('/coupon/couponsExpiredList', params)

/**
 * 标记已作废券状态
 *      id：过期券ID
 *      type：1-已换券，2-已作废
*/
export const updateExpiredStatusApi = (id:number, type:number) => $http.get('/coupon/couponsExpiredSaveStatus', { id, type })

/**
 * 卡券延期
*/
export const updateCouponDelayApi = (user_coupon_id:number|string, valid_to:number|string) => $http.post('/opsapi/longer_coupon', { user_coupon_id, valid_to })
